import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

// =============================================================================
// Saltar el aviso de ngrok (solo mientras la API de pruebas viva en un túnel)
// =============================================================================
//
// EL PROBLEMA (detectado probando prueba.hakire.com contra un backend expuesto
// por ngrok, Septiembre 2026): ngrok, en su plan gratis, intercepta la PRIMERA
// visita de cada navegador a la URL del túnel y le muestra una página de aviso
// ("You are about to visit... served for free through ngrok.com") en vez de
// dejar pasar la petición al backend real. Esa página de aviso no trae los
// headers de CORS, así que el navegador terminaba mostrando "bloqueado por
// política de CORS" en TODAS las llamadas a la API - el error parecía de CORS
// pero el verdadero causante era ngrok, no el backend ni Angular.
//
// LA SOLUCIÓN (documentada por el propio ngrok): mandar el header
// "ngrok-skip-browser-warning" en cada petición. Con eso presente, ngrok deja
// pasar la petición directo al backend sin mostrar el aviso.
//
// POR QUÉ SOLO CUANDO LA URL ES DE NGROK
// Este header no tiene ningún efecto en hakire.com real (no pasa por ngrok),
// así que mandarlo siempre sería inofensivo - pero se restringe a propósito
// para no ensuciar cada petición de producción con un header que ahí no
// significa nada, y para que quede claro en el código que esto es un parche
// de un entorno de pruebas temporal, no parte del comportamiento normal del
// sitio.
export const ngrokSkipWarningInterceptor: HttpInterceptorFn = (req, next) => {
  if (!environment.apiBaseUrl.includes('ngrok')) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { 'ngrok-skip-browser-warning': 'true' },
    })
  );
};
